"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Const, Course, Fu, Gi, Hi, Ka, Ke, Ki, Ky, Ou, Piece;

Const = require('./const');

Course = function Course() {
  var series = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var xd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var yd = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  _classCallCheck(this, Course);

  this.series = series;
  this.xd = xd;
  this.yd = yd;
};

Piece = function () {
  var uniqueId;

  var Piece = function () {
    function Piece(turn1, status1) {
      var posi1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      _classCallCheck(this, Piece);

      this.turn = turn1;
      this.status = status1;
      this.posi = posi1;
      this.posi = this.posi != null ? this.posi.concat() : [];
      this.id = uniqueId.call(this);
    }

    _createClass(Piece, [{
      key: "setTurn",
      value: function setTurn(turn) {
        if (turn !== this.turn) {
          return this.turn = turn;
        }
      }
    }]);

    return Piece;
  }();

  ;

  uniqueId = function uniqueId() {
    var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;

    var id;
    id = "";
    while (id.length < length) {
      id += Math.random().toString(36).substr(2);
    }
    return id.substr(0, length);
  };

  return Piece;
}();

Ou = function () {
  var _direction;

  var Ou = function (_Piece) {
    _inherits(Ou, _Piece);

    _createClass(Ou, null, [{
      key: "getD",
      value: function getD(turn, status) {
        return _direction[status][turn];
      }
    }]);

    function Ou(turn, status, posi) {
      _classCallCheck(this, Ou);

      return _possibleConstructorReturn(this, (Ou.__proto__ || Object.getPrototypeOf(Ou)).call(this, turn, status, posi));
    }

    _createClass(Ou, [{
      key: "kind",
      value: function kind() {
        return this.constructor.name;
      }
    }, {
      key: "koma",
      value: function koma() {
        return "OU";
      }
    }, {
      key: "omomi",
      value: function omomi() {
        switch (this.status) {
          case Const.Status.OMOTE:
            return 9999;
          case Const.Status.URA:
            return 9999;
          case Const.Status.MOTIGOMA:
            return 9999;
          default:
            return 0;
        }
      }
    }, {
      key: "caption",
      value: function caption() {
        switch (this.status) {
          case Const.Status.OMOTE:
            if (this.turn === Const.FIRST) {
              return 'O';
            } else {
              return 'o';
            }
            break;
          case Const.Status.URA:
            if (this.turn === Const.FIRST) {
              return 'O';
            } else {
              return 'o';
            }
            break;
          case Const.Status.MOTIGOMA:
            if (this.turn === Const.FIRST) {
              return 'O';
            } else {
              return 'o';
            }
        }
      }
    }]);

    return Ou;
  }(Piece);

  ;

  _direction = {};

  _direction[Const.Status.OMOTE] = {};

  _direction[Const.Status.URA] = {};

  _direction[Const.Status.MOTIGOMA] = {};

  _direction[Const.Status.OMOTE][Const.FIRST] = [new Course(false, 0, -1), new Course(false, -1, -1), new Course(false, -1, 0), new Course(false, -1, 1), new Course(false, 0, 1), new Course(false, 1, 1), new Course(false, 1, 0), new Course(false, 1, -1)];

  _direction[Const.Status.OMOTE][Const.SECOND] = [new Course(false, 0, 1), new Course(false, 1, 1), new Course(false, 1, 0), new Course(false, 1, -1), new Course(false, 0, -1), new Course(false, -1, -1), new Course(false, -1, 0), new Course(false, -1, 1)];

  _direction[Const.Status.URA][Const.FIRST] = [];

  _direction[Const.Status.URA][Const.SECOND] = [];

  _direction[Const.Status.MOTIGOMA][Const.FIRST] = [];

  _direction[Const.Status.MOTIGOMA][Const.SECOND] = [];

  return Ou;
}();

Hi = function () {
  var _direction;

  var Hi = function (_Piece2) {
    _inherits(Hi, _Piece2);

    _createClass(Hi, null, [{
      key: "getD",
      value: function getD(turn, status) {
        return _direction[status][turn];
      }
    }]);

    function Hi(turn, status, posi) {
      _classCallCheck(this, Hi);

      return _possibleConstructorReturn(this, (Hi.__proto__ || Object.getPrototypeOf(Hi)).call(this, turn, status, posi));
    }

    _createClass(Hi, [{
      key: "kind",
      value: function kind() {
        return this.constructor.name;
      }
    }, {
      key: "koma",
      value: function koma() {
        if (this.status === Const.Status.URA) {
          return "RY";
        } else {
          return "HI";
        }
      }
    }, {
      key: "omomi",
      value: function omomi() {
        switch (this.status) {
          case Const.Status.OMOTE:
            return 85;
          case Const.Status.URA:
            return 110;
          case Const.Status.MOTIGOMA:
            return 75;
          default:
            return 0;
        }
      }
    }, {
      key: "caption",
      value: function caption() {
        switch (this.status) {
          case Const.Status.OMOTE:
            if (this.turn === Const.FIRST) {
              return 'H';
            } else {
              return 'h';
            }
            break;
          case Const.Status.URA:
            if (this.turn === Const.FIRST) {
              return 'R';
            } else {
              return 'r';
            }
            break;
          case Const.Status.MOTIGOMA:
            if (this.turn === Const.FIRST) {
              return 'H';
            } else {
              return 'h';
            }
        }
      }
    }]);

    return Hi;
  }(Piece);

  ;

  _direction = {};

  _direction[Const.Status.OMOTE] = {};

  _direction[Const.Status.URA] = {};

  _direction[Const.Status.MOTIGOMA] = {};

  _direction[Const.Status.OMOTE][Const.FIRST] = [new Course(true, 0, -1), new Course(true, -1, 0), new Course(true, 0, 1), new Course(true, 1, 0)];

  _direction[Const.Status.OMOTE][Const.SECOND] = [new Course(true, 0, 1), new Course(true, 1, 0), new Course(true, 0, -1), new Course(true, -1, 0)];

  _direction[Const.Status.URA][Const.FIRST] = [new Course(true, 0, -1), new Course(false, -1, -1), new Course(true, -1, 0), new Course(false, -1, 1), new Course(true, 0, 1), new Course(false, 1, 1), new Course(true, 1, 0), new Course(false, 1, -1)];

  _direction[Const.Status.URA][Const.SECOND] = [new Course(true, 0, 1), new Course(false, 1, 1), new Course(true, 1, 0), new Course(false, 1, -1), new Course(true, 0, -1), new Course(false, -1, -1), new Course(true, -1, 0), new Course(false, -1, 1)];

  _direction[Const.Status.MOTIGOMA][Const.FIRST] = [new Course(true, 0, -1), new Course(true, -1, 0), new Course(true, 0, 1), new Course(true, 1, 0)];

  _direction[Const.Status.MOTIGOMA][Const.SECOND] = [new Course(true, 0, 1), new Course(true, 1, 0), new Course(true, 0, -1), new Course(true, -1, 0)];

  return Hi;
}();

Ka = function () {
  var _direction;

  var Ka = function (_Piece3) {
    _inherits(Ka, _Piece3);

    _createClass(Ka, null, [{
      key: "getD",
      value: function getD(turn, status) {
        return _direction[status][turn];
      }
    }]);

    function Ka(turn, status, posi) {
      _classCallCheck(this, Ka);

      return _possibleConstructorReturn(this, (Ka.__proto__ || Object.getPrototypeOf(Ka)).call(this, turn, status, posi));
    }

    _createClass(Ka, [{
      key: "kind",
      value: function kind() {
        return this.constructor.name;
      }
    }, {
      key: "koma",
      value: function koma() {
        if (this.status === Const.Status.URA) {
          return "UM";
        } else {
          return "KA";
        }
      }
    }, {
      key: "omomi",
      value: function omomi() {
        switch (this.status) {
          case Const.Status.OMOTE:
            return 75;
          case Const.Status.URA:
            return 100;
          case Const.Status.MOTIGOMA:
            return 65;
          default:
            return 0;
        }
      }
    }, {
      key: "caption",
      value: function caption() {
        switch (this.status) {
          case Const.Status.OMOTE:
            if (this.turn === Const.FIRST) {
              return 'M';
            } else {
              return 'm';
            }
            break;
          case Const.Status.URA:
            if (this.turn === Const.FIRST) {
              return 'U';
            } else {
              return 'u';
            }
            break;
          case Const.Status.MOTIGOMA:
            if (this.turn === Const.FIRST) {
              return 'M';
            } else {
              return 'm';
            }
        }
      }
    }]);

    return Ka;
  }(Piece);

  ;

  _direction = {};

  _direction[Const.Status.OMOTE] = {};

  _direction[Const.Status.URA] = {};

  _direction[Const.Status.MOTIGOMA] = {};

  _direction[Const.Status.OMOTE][Const.FIRST] = [new Course(true, -1, -1), new Course(true, -1, 1), new Course(true, 1, 1), new Course(true, 1, -1)];

  _direction[Const.Status.OMOTE][Const.SECOND] = [new Course(true, 1, 1), new Course(true, 1, -1), new Course(true, -1, -1), new Course(true, -1, 1)];

  _direction[Const.Status.URA][Const.FIRST] = [new Course(false, 0, -1), new Course(true, -1, -1), new Course(false, -1, 0), new Course(true, -1, 1), new Course(false, 0, 1), new Course(true, 1, 1), new Course(false, 1, 0), new Course(true, 1, -1)];

  _direction[Const.Status.URA][Const.SECOND] = [new Course(false, 0, 1), new Course(true, 1, 1), new Course(false, 1, 0), new Course(true, 1, -1), new Course(false, 0, -1), new Course(true, -1, -1), new Course(false, -1, 0), new Course(true, -1, 1)];

  _direction[Const.Status.MOTIGOMA][Const.FIRST] = [new Course(true, -1, -1), new Course(true, -1, 1), new Course(true, 1, 1), new Course(true, 1, -1)];

  _direction[Const.Status.MOTIGOMA][Const.SECOND] = [new Course(true, 1, 1), new Course(true, 1, -1), new Course(true, -1, -1), new Course(true, -1, 1)];

  return Ka;
}();

Ki = function () {
  var _direction;

  var Ki = function (_Piece4) {
    _inherits(Ki, _Piece4);

    _createClass(Ki, null, [{
      key: "getD",
      value: function getD(turn, status) {
        return _direction[status][turn];
      }
    }]);

    function Ki(turn, status, posi) {
      _classCallCheck(this, Ki);

      return _possibleConstructorReturn(this, (Ki.__proto__ || Object.getPrototypeOf(Ki)).call(this, turn, status, posi));
    }

    _createClass(Ki, [{
      key: "kind",
      value: function kind() {
        return this.constructor.name;
      }
    }, {
      key: "koma",
      value: function koma() {
        return "KI";
      }
    }, {
      key: "omomi",
      value: function omomi() {
        switch (this.status) {
          case Const.Status.OMOTE:
            return 50;
          case Const.Status.URA:
            return 50;
          case Const.Status.MOTIGOMA:
            return 45;
          default:
            return 0;
        }
      }
    }, {
      key: "caption",
      value: function caption() {
        switch (this.status) {
          case Const.Status.OMOTE:
            if (this.turn === Const.FIRST) {
              return 'X';
            } else {
              return 'x';
            }
            break;
          case Const.Status.URA:
            if (this.turn === Const.FIRST) {
              return 'X';
            } else {
              return 'x';
            }
            break;
          case Const.Status.MOTIGOMA:
            if (this.turn === Const.FIRST) {
              return 'X';
            } else {
              return 'x';
            }
        }
      }
    }]);

    return Ki;
  }(Piece);

  ;

  _direction = {};

  _direction[Const.Status.OMOTE] = {};

  _direction[Const.Status.URA] = {};

  _direction[Const.Status.MOTIGOMA] = {};

  _direction[Const.Status.OMOTE][Const.FIRST] = [new Course(false, 0, -1), new Course(false, -1, -1), new Course(false, -1, 0), new Course(false, 0, 1), new Course(false, 1, 0), new Course(false, 1, -1)];

  _direction[Const.Status.OMOTE][Const.SECOND] = [new Course(false, 0, 1), new Course(false, 1, 1), new Course(false, 1, 0), new Course(false, 0, -1), new Course(false, -1, 0), new Course(false, -1, 1)];

  _direction[Const.Status.URA][Const.FIRST] = [];

  _direction[Const.Status.URA][Const.SECOND] = [];

  _direction[Const.Status.MOTIGOMA][Const.FIRST] = [new Course(false, 0, -1), new Course(false, -1, -1), new Course(false, -1, 0), new Course(false, 0, 1), new Course(false, 1, 0), new Course(false, 1, -1)];

  _direction[Const.Status.MOTIGOMA][Const.SECOND] = [new Course(false, 0, 1), new Course(false, 1, 1), new Course(false, 1, 0), new Course(false, 0, -1), new Course(false, -1, 0), new Course(false, -1, 1)];

  return Ki;
}();

Gi = function () {
  var _direction;

  var Gi = function (_Piece5) {
    _inherits(Gi, _Piece5);

    _createClass(Gi, null, [{
      key: "getD",
      value: function getD(turn, status) {
        return _direction[status][turn];
      }
    }]);

    function Gi(turn, status, posi) {
      _classCallCheck(this, Gi);

      return _possibleConstructorReturn(this, (Gi.__proto__ || Object.getPrototypeOf(Gi)).call(this, turn, status, posi));
    }

    _createClass(Gi, [{
      key: "kind",
      value: function kind() {
        return this.constructor.name;
      }
    }, {
      key: "koma",
      value: function koma() {
        if (this.status === Const.Status.URA) {
          return "NG";
        } else {
          return "GI";
        }
      }
    }, {
      key: "omomi",
      value: function omomi() {
        switch (this.status) {
          case Const.Status.OMOTE:
            return 45;
          case Const.Status.URA:
            return 50;
          case Const.Status.MOTIGOMA:
            return 40;
          default:
            return 0;
        }
      }
    }, {
      key: "caption",
      value: function caption() {
        switch (this.status) {
          case Const.Status.OMOTE:
            if (this.turn === Const.FIRST) {
              return 'G';
            } else {
              return 'g';
            }
            break;
          case Const.Status.URA:
            if (this.turn === Const.FIRST) {
              return 'N';
            } else {
              return 'n';
            }
            break;
          case Const.Status.MOTIGOMA:
            if (this.turn === Const.FIRST) {
              return 'G';
            } else {
              return 'g';
            }
        }
      }
    }]);

    return Gi;
  }(Piece);

  ;

  _direction = {};

  _direction[Const.Status.OMOTE] = {};

  _direction[Const.Status.URA] = {};

  _direction[Const.Status.MOTIGOMA] = {};

  _direction[Const.Status.OMOTE][Const.FIRST] = [new Course(false, 0, -1), new Course(false, -1, -1), new Course(false, -1, 1), new Course(false, 1, 1), new Course(false, 1, -1)];

  _direction[Const.Status.OMOTE][Const.SECOND] = [new Course(false, 0, 1), new Course(false, 1, 1), new Course(false, 1, -1), new Course(false, -1, -1), new Course(false, -1, 1)];

  _direction[Const.Status.URA][Const.FIRST] = [new Course(false, 0, -1), new Course(false, -1, -1), new Course(false, -1, 0), new Course(false, 0, 1), new Course(false, 1, 0), new Course(false, 1, -1)];

  _direction[Const.Status.URA][Const.SECOND] = [new Course(false, 0, 1), new Course(false, 1, 1), new Course(false, 1, 0), new Course(false, 0, -1), new Course(false, -1, 0), new Course(false, -1, 1)];

  _direction[Const.Status.MOTIGOMA][Const.FIRST] = [new Course(false, 0, -1), new Course(false, -1, -1), new Course(false, -1, 1), new Course(false, 1, 1), new Course(false, 1, -1)];

  _direction[Const.Status.MOTIGOMA][Const.SECOND] = [new Course(false, 0, 1), new Course(false, 1, 1), new Course(false, 1, -1), new Course(false, -1, -1), new Course(false, -1, 1)];

  return Gi;
}();

Ke = function () {
  var _direction;

  var Ke = function (_Piece6) {
    _inherits(Ke, _Piece6);

    _createClass(Ke, null, [{
      key: "getD",
      value: function getD(turn, status) {
        return _direction[status][turn];
      }
    }]);

    function Ke(turn, status, posi) {
      _classCallCheck(this, Ke);

      return _possibleConstructorReturn(this, (Ke.__proto__ || Object.getPrototypeOf(Ke)).call(this, turn, status, posi));
    }

    _createClass(Ke, [{
      key: "kind",
      value: function kind() {
        return this.constructor.name;
      }
    }, {
      key: "koma",
      value: function koma() {
        if (this.status === Const.Status.URA) {
          return "NK";
        } else {
          return "KE";
        }
      }
    }, {
      key: "omomi",
      value: function omomi() {
        switch (this.status) {
          case Const.Status.OMOTE:
            return 30;
          case Const.Status.URA:
            return 50;
          case Const.Status.MOTIGOMA:
            return 25;
          default:
            return 0;
        }
      }
    }, {
      key: "caption",
      value: function caption() {
        switch (this.status) {
          case Const.Status.OMOTE:
            if (this.turn === Const.FIRST) {
              return 'K';
            } else {
              return 'k';
            }
            break;
          case Const.Status.URA:
            if (this.turn === Const.FIRST) {
              return 'E';
            } else {
              return 'e';
            }
            break;
          case Const.Status.MOTIGOMA:
            if (this.turn === Const.FIRST) {
              return 'K';
            } else {
              return 'k';
            }
        }
      }
    }]);

    return Ke;
  }(Piece);

  ;

  _direction = {};

  _direction[Const.Status.OMOTE] = {};

  _direction[Const.Status.URA] = {};

  _direction[Const.Status.MOTIGOMA] = {};

  _direction[Const.Status.OMOTE][Const.FIRST] = [new Course(false, 1, -2), new Course(false, -1, -2)];

  _direction[Const.Status.OMOTE][Const.SECOND] = [new Course(false, -1, 2), new Course(false, 1, 2)];

  _direction[Const.Status.URA][Const.FIRST] = [new Course(false, 0, -1), new Course(false, -1, -1), new Course(false, -1, 0), new Course(false, 0, 1), new Course(false, 1, 0), new Course(false, 1, -1)];

  _direction[Const.Status.URA][Const.SECOND] = [new Course(false, 0, 1), new Course(false, 1, 1), new Course(false, 1, 0), new Course(false, 0, -1), new Course(false, -1, 0), new Course(false, -1, 1)];

  _direction[Const.Status.MOTIGOMA][Const.FIRST] = [new Course(false, 1, -2), new Course(false, -1, -2)];

  _direction[Const.Status.MOTIGOMA][Const.SECOND] = [new Course(false, -1, 2), new Course(false, 1, 2)];

  return Ke;
}();

Ky = function () {
  var _direction;

  var Ky = function (_Piece7) {
    _inherits(Ky, _Piece7);

    _createClass(Ky, null, [{
      key: "getD",
      value: function getD(turn, status) {
        return _direction[status][turn];
      }
    }]);

    function Ky(turn, status, posi) {
      _classCallCheck(this, Ky);

      return _possibleConstructorReturn(this, (Ky.__proto__ || Object.getPrototypeOf(Ky)).call(this, turn, status, posi));
    }

    _createClass(Ky, [{
      key: "kind",
      value: function kind() {
        return this.constructor.name;
      }
    }, {
      key: "koma",
      value: function koma() {
        if (this.status === Const.Status.URA) {
          return "NY";
        } else {
          return "KY";
        }
      }
    }, {
      key: "omomi",
      value: function omomi() {
        switch (this.status) {
          case Const.Status.OMOTE:
            return 25;
          case Const.Status.URA:
            return 50;
          case Const.Status.MOTIGOMA:
            return 20;
          default:
            return 0;
        }
      }
    }, {
      key: "caption",
      value: function caption() {
        switch (this.status) {
          case Const.Status.OMOTE:
            if (this.turn === Const.FIRST) {
              return 'Y';
            } else {
              return 'y';
            }
            break;
          case Const.Status.URA:
            if (this.turn === Const.FIRST) {
              return 'S';
            } else {
              return 's';
            }
            break;
          case Const.Status.MOTIGOMA:
            if (this.turn === Const.FIRST) {
              return 'Y';
            } else {
              return 'y';
            }
        }
      }
    }]);

    return Ky;
  }(Piece);

  ;

  _direction = {};

  _direction[Const.Status.OMOTE] = {};

  _direction[Const.Status.URA] = {};

  _direction[Const.Status.MOTIGOMA] = {};

  _direction[Const.Status.OMOTE][Const.FIRST] = [new Course(true, 0, -1)];

  _direction[Const.Status.OMOTE][Const.SECOND] = [new Course(true, 0, 1)];

  _direction[Const.Status.URA][Const.FIRST] = [new Course(false, 0, -1), new Course(false, -1, -1), new Course(false, -1, 0), new Course(false, 0, 1), new Course(false, 1, 0), new Course(false, 1, -1)];

  _direction[Const.Status.URA][Const.SECOND] = [new Course(false, 0, 1), new Course(false, 1, 1), new Course(false, 1, 0), new Course(false, 0, -1), new Course(false, -1, 0), new Course(false, -1, 1)];

  _direction[Const.Status.MOTIGOMA][Const.FIRST] = [new Course(true, 0, -1)];

  _direction[Const.Status.MOTIGOMA][Const.SECOND] = [new Course(true, 0, 1)];

  return Ky;
}();

Fu = function () {
  var _direction;

  var Fu = function (_Piece8) {
    _inherits(Fu, _Piece8);

    _createClass(Fu, null, [{
      key: "getD",
      value: function getD(turn, status) {
        return _direction[status][turn];
      }
    }]);

    function Fu(turn, status, posi) {
      _classCallCheck(this, Fu);

      return _possibleConstructorReturn(this, (Fu.__proto__ || Object.getPrototypeOf(Fu)).call(this, turn, status, posi));
    }

    _createClass(Fu, [{
      key: "kind",
      value: function kind() {
        return this.constructor.name;
      }
    }, {
      key: "koma",
      value: function koma() {
        if (this.status === Const.Status.URA) {
          return "TO";
        } else {
          return "FU";
        }
      }
    }, {
      key: "omomi",
      value: function omomi() {
        switch (this.status) {
          case Const.Status.OMOTE:
            return 10;
          case Const.Status.URA:
            return 50;
          case Const.Status.MOTIGOMA:
            return 7;
          default:
            return 0;
        }
      }
    }, {
      key: "caption",
      value: function caption() {
        switch (this.status) {
          case Const.Status.OMOTE:
            if (this.turn === Const.FIRST) {
              return 'F';
            } else {
              return 'f';
            }
            break;
          case Const.Status.URA:
            if (this.turn === Const.FIRST) {
              return 'T';
            } else {
              return 't';
            }
            break;
          case Const.Status.MOTIGOMA:
            if (this.turn === Const.FIRST) {
              return 'F';
            } else {
              return 'f';
            }
        }
      }
    }]);

    return Fu;
  }(Piece);

  ;

  _direction = {};

  _direction[Const.Status.OMOTE] = {};

  _direction[Const.Status.URA] = {};

  _direction[Const.Status.MOTIGOMA] = {};

  _direction[Const.Status.OMOTE][Const.FIRST] = [new Course(false, 0, -1)];

  _direction[Const.Status.OMOTE][Const.SECOND] = [new Course(false, 0, 1)];

  _direction[Const.Status.URA][Const.FIRST] = [new Course(false, 0, -1), new Course(false, -1, -1), new Course(false, -1, 0), new Course(false, 0, 1), new Course(false, 1, 0), new Course(false, 1, -1)];

  _direction[Const.Status.URA][Const.SECOND] = [new Course(false, 0, 1), new Course(false, 1, 1), new Course(false, 1, 0), new Course(false, 0, -1), new Course(false, -1, 0), new Course(false, -1, 1)];

  _direction[Const.Status.MOTIGOMA][Const.FIRST] = [new Course(false, 0, -1)];

  _direction[Const.Status.MOTIGOMA][Const.SECOND] = [new Course(false, 0, 1)];

  return Fu;
}();

module.exports = {
  Course: Course,
  Piece: Piece,
  Ou: Ou,
  Hi: Hi,
  Ka: Ka,
  Ki: Ki,
  Gi: Gi,
  Ke: Ke,
  Ky: Ky,
  Fu: Fu
};


//////////////////
// WEBPACK FOOTER
// ./piece.coffee
// module id = 64
// module chunks = 0